/**
 * Ahlam ink-curtain page transition.
 * Intercepts internal link clicks, slides dark curtain up with the maison mark,
 * navigates after 520ms, then slides curtain down on the new page.
 * Skipped on reduced motion. Respects target="_blank", external links, hash/mail/tel.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const SHOULD_INTERCEPT = (a) => {
    if (!a) return false;
    if (a.target === '_blank') return false;
    if (a.hasAttribute('download')) return false;

    const href = a.getAttribute('href');
    if (!href) return false;
    if (href.startsWith('#')) return false;
    if (href.startsWith('mailto:')) return false;
    if (href.startsWith('tel:')) return false;
    if (href.startsWith('javascript:')) return false;

    // External link?
    if (/^https?:\/\//i.test(href)) {
      try {
        if (new URL(href).origin !== window.location.origin) return false;
      } catch (_) {
        return false;
      }
    }

    // Allow shopify checkout / cart change links that depend on form posts to pass through
    if (href.includes('/checkouts/') || href.includes('/checkout')) return false;
    if (href.includes('/cart/change') || href.includes('/cart/add')) return false;

    // Skip if Horizon view-transition will handle it (transition-to-main-product)
    if (a.closest('[data-product-card-link]')) return false;
    if (a.hasAttribute('data-no-transition')) return false;
    // Skip quick-add / dialog / cart drawer triggers
    if (a.matches('[aria-controls], [data-toggle], [popovertarget]')) return false;
    if (a.closest('cart-drawer, cart-icon, predictive-search, search-modal')) return false;
    if (href === '/cart' && document.querySelector('cart-drawer')) return false;

    return true;
  };

  const init = () => {
    if (document.getElementById('ahlam-curtain')) return;

    const curtain = document.createElement('div');
    curtain.id = 'ahlam-curtain';
    curtain.innerHTML =
      '<div class="curtain-inner"><img class="curtain-mark" src="https://cdn.shopify.com/s/files/1/0926/6384/1101/files/Elegant_blue_logo_on_black_background_1.png?v=1779269261" alt="Ahlam Copenhagen"></div>';
    document.body.appendChild(curtain);

    document.addEventListener('click', (e) => {
      // Skip if modifier keys
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.defaultPrevented) return;

      const a = e.target && e.target.closest && e.target.closest('a');
      if (!SHOULD_INTERCEPT(a)) return;

      e.preventDefault();
      curtain.classList.add('is-active');

      const href = a.getAttribute('href');
      window.setTimeout(() => {
        window.location.href = href;
      }, 520);
    });

    // On back/forward / bfcache restore, slide curtain back down
    window.addEventListener('pageshow', (e) => {
      if (curtain.classList.contains('is-active')) {
        curtain.classList.remove('is-active');
        curtain.classList.add('is-exiting');
        window.setTimeout(() => {
          curtain.classList.remove('is-exiting');
        }, 700);
      }
    });
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
